import {commonWebSocket} from '@services/common/common.constants';
import {createReducer} from 'redux-act';

const defaultState: {readArticles: number[]} = {readArticles: []};
const reducer = createReducer<typeof defaultState>({}, defaultState);

reducer.on(commonWebSocket.special.READ_ARTICLES_UPDATE, (state, payload: any) => {
  const readArticles = Array.isArray(state.readArticles) ? state.readArticles.slice() : [];
  if (Array.isArray(payload?.readArticles)) {
    for (const id of payload.readArticles) {
      if (typeof id === 'number' && !readArticles.includes(id)) readArticles.push(id);
    }
  }
  return {readArticles};
});

export default reducer;



// WEBPACK FOOTER //
// ./src/services/article/article.reducer.ts